<template>
  <div>
    <h2 class="bordered-box-header">Szczegóły wybranego kursu</h2>
    <b-container fluid class="bordered-box">
      <b-row class="justify-content-center" v-if="loading">
        <b-spinner big label="Loading..."></b-spinner>
      </b-row>
      <b-row v-else-if="course">
        <b-col cols="12">
          <h3>
            {{course.name}}
            <span
              class="text-lowercase font-italic"
            >({{course.languageProficiency | languageProficiency}})</span>
          </h3>
          <p>{{course.description}}</p>
        </b-col>
        <b-col cols="12">
          <button class="btn btn-primary edit-item" @click="showEditCourseModal">Edytuj</button>
          <button
            v-if="!course.locked"
            class="btn btn-danger delete-item"
            @click="removeCourseModal"
          >Usuń</button>
          <hr />
        </b-col>

        <b-col xl="6" cols="12">
          <h3 class="big-margin">Tematy zrealizowane / w trakcie realizacji</h3>
          <span v-if="!lockedItems.length" class="text-danger">Brak tematów</span>
          <b-row
            v-for="item in lockedItems"
            :key="item.id"
            class="item locked-item"
            :class="{'selected-item': selectedItem == item}"
            @click="selectedItem = item"
            no-gutters
          >
            <span>{{item.title}} ({{item.dateFrom | date}} - {{item.dateTo | date}})</span>
          </b-row>
        </b-col>

        <b-col xl="6" cols="12" v-if="!course.subjectsLocked">
          <h3 class="big-margin">Tematy zaplanowane do realizacji</h3>
          <button class="btn btn-primary add-item" @click="showAddNewSubjectModal">Utwórz nowy temat</button>
          <button
            class="btn btn-secondary add-item"
            @click="showAssignSubjectTemplateModal"
          >Przypisz temat</button>

          <draggable
            v-model="activeItems"
            @start="drag=true"
            @end="drag=false"
            @change="onOrderChanged"
          >
            <b-row
              v-for="item in activeItems"
              :key="item.id"
              class="item active-item"
              :class="{'selected-item': selectedItem == item}"
              @click="selectedItem = item"
              no-gutters
            >
              <span>{{item.title}}</span>
            </b-row>
          </draggable>
        </b-col>
      </b-row>
    </b-container>

    <subjectDetails
      v-if="selectedItem"
      :id="selectedItem.id"
      :key="selectedItem.id"
      @changed="onSelectedItemChanged"
      @deleted="onSelectedItemDeleted"
    />

    <editCourseModal ref="editCourseModal" @save="onEditCourse" :course="course" />
    <addNewSubjectModal ref="addNewSubjectModal" @save="onAddNewSubject" />
    <assignSubjectTemplateModal ref="assignSubjectTemplateModal" @save="onAssignSubjectTemplate" />
  </div>
</template>
<script>
import { axios, eventBus } from "@/_infrastructure";
import draggable from "vuedraggable";
import editCourseModal from "./DetailsCourseAddEditCourseModal";
import addNewSubjectModal from "./DetailsCourseAddEditSubjectModal";
import assignSubjectTemplateModal from "./DetailsCourseAssignSubjectTemplateModal";
import subjectDetails from "./DetailsCourseSubjectItem";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      course: null,
      selectedItem: null,
      activeItems: [],
      lockedItems: []
    };
  },
  props: ["id"],
  components: {
    draggable,
    editCourseModal,
    addNewSubjectModal,
    assignSubjectTemplateModal,
    subjectDetails
  },
  mounted() {
    if (this.id) {
      this.refresh();
    }
  },
  methods: {
    onOrderChanged() {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      var r = {
        courseId: this.id,
        items: this.activeItems.map(e => e.id)
      };

      axios
        .post("/courses/subjects/order", r)
        .then(() => {
          eventBus.$emit("notify-success", "Zapisano poprawnie.");
        })
        .catch(error => {
          eventBus.$emit("unhandled-error", error);
          this.refresh();
        })
        .then(() => {
          loader.hide();
        });
    },
    removeCourseModal() {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz usunąć wskazany kurs?")
        .then(value => {
          if (value) {
            this.onDeleteCourse();
          }
        });
    },
    showEditCourseModal() {
      this.$refs.editCourseModal.show();
    },
    refresh() {
      this.loading = true;

      axios
        .get("/courses/details", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          this.course = response.data;

          this.activeItems = this.course.subjects.filter(s => !s.locked);
          this.lockedItems = this.course.subjects.filter(s => s.locked);
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
        });
    },
    onEditCourse(r) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      r.id = this.id;

      axios
        .put("/courses", r)
        .then(response => {
          var result = response.data;

          this.course.name = result.name;
          this.course.description = result.description;
          this.course.languageProficiency = result.languageProficiency;

          eventBus.$emit("notify-success", "Zapisano poprawnie.");
          this.$emit("changed", response.data);
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    onDeleteCourse() {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      axios
        .delete("/courses", {
          params: {
            id: this.id
          }
        })
        .then(() => {
          eventBus.$emit("notify-success", "Kurs usunięto poprawnie.");
          this.$emit("deleted");
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    showAddNewSubjectModal() {
      this.$refs.addNewSubjectModal.show();
    },
    showAssignSubjectTemplateModal() {
      this.$refs.assignSubjectTemplateModal.show();
    },
    onAddNewSubject(r) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      r.courseId = this.id;

      axios
        .post("/subjects", r)
        .then(response => {
          eventBus.$emit("notify-success", "Zapisano poprawnie.");
          var result = response.data;
          this.activeItems.push(result);
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    onAssignSubjectTemplate(id) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      var postParams = {
        courseId: this.id,
        templateId: id
      };

      axios
        .post("/subjects/template", postParams)
        .then(response => {
          eventBus.$emit("notify-success", "Zapisano poprawnie.");
          var result = response.data;
          this.activeItems.push(result);
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    onSelectedItemChanged(data) {
      this.selectedItem.title = data.title;
    },
    onSelectedItemDeleted() {
      this.activeItems = this.activeItems.filter(
        s => s.id != this.selectedItem.id
      );
      this.selectedItem = null;
    },
    moment: function() {
      return moment();
    }
  },
  filters: {
    date(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "-";
    }
  }
};
</script>
<style lang="scss" scoped>
.item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  background: rgba(0, 0, 0, 0.03);
  border-radius: 1px;
  padding: 5px;
  margin-bottom: -1px;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }
}
.active-item {
  cursor: move;
}
.selected-item {
  background: rgba(0, 255, 0, 0.125);

  &:hover {
    background: rgba(0, 255, 0, 0.25);
  }
}
.add-item,
.edit-item,
.delete-item {
  margin: 0px 10px 10px 0px;
}

h2.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>
